<template>
	<div
		class="modal"
		id="oldAddCampaignGroup"
		data-backdrop = "static"
		tabindex="-1"
		role="dialog"
		aria-labelledby="addCampaignGroup"
		aria-hidden="true"
	>
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content campaign-g-addedit">
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLongTitle">Creating Campaign Group</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<h2 class="text-center">Add Campaign Group</h2>
					<div class="form-container" style="width:90%">
						<span style="color: red" id="errorMsgAdd"></span>
						<form>
							<div class="form-group">
								<label style="padding:0px">Campaign Group Name</label>
								<div class="row">
									<div class="col-md-11">
										<input
											type="text"
											v-model="Item.name"
											placeholder="Enter Name"
											class="form-control"
											id="addCampaignGroupName"
											v-on:blur="checkDuplicate(Item.name)"
											v-on:click="hideSpan()"
										>
									</div>
									<div v-if="this.showLoader" class="spinner-border"></div>
								</div>
								<span
									v-if="showSpan"
									style="color:red;font-size:13px;"
								>Camapign group already exist with same name</span>
							</div>
							<div class="form-group">
								<label>D Budget($)</label>
								<input
									type="text"
									v-model="Item.daily_budget"
									placeholder="Enter amount"
									class="form-control col-md-11"
									id="addCampaignGroupDailyBudget"
								>
							</div>
							<div class="form-group">
								<label>Strategy</label>
								<div class="row">
									<div class="col-md-5">
										<div
											id="sales"
											class="strategy"
											@click="Item.strategy = 'Sales'"
											:class="Item.strategy == 'Sales' ? 'sales' : ''"
										>Sales</div>
									</div>

									<div class="col-md-5">
										<div
											id="roi"
											class="strategy"
											@click="Item.strategy = 'ROI'"
											:class="Item.strategy == 'ROI' ? 'roi' : ''"
										>ROI</div>
									</div>
								</div>
							</div>
							<div class="form-group" id="add_constraints" v-if="Item.strategy == 'ROI'">
								<label>Constraint: Minimum Spend</label>
								<select id="add_lb_spend" class="form-control">
									<option value>--- Select ---</option>
									<option value="10">10% of Budget</option>
									<option value="25">25% of Budget</option>
									<option value="20">20% of Budget</option>
									<option value="30">30% of Budget</option>
									<option value="40">40% of Budget</option>
									<option value="50">50% of Budget</option>
									<option value="60">60% of Budget</option>
									<option value="70">70% of Budget</option>
									<option value="75">75% of Budget</option>
									<option value="80">80% of Budget</option>
									<option value="90">90% of Budget</option>
									<option value="100">100% of Budget</option>
								</select>
							</div>
						</form>
						<!-- form end-->
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" v-on:click="cancelNewCampaignGroup" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
					<button
						type="button"
						class="btn btn-primary"
						data-dismiss="modal"
						v-on:click="saveNewCampaignGroup"
					>Save changes</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Multiselect from "vue-multiselect";


export default {
	name: "OldAddCampaignGroupModal",
	data() {
		return {
			Item: {
				requestType: "submit",
				name: "",
				daily_budget: "",
				strategy: ""
			},
			showLoader: false,
			showSpan: false
		};
	},
	components:{
		Multiselect
	},
	mounted(){

	},
	methods: {
		saveNewCampaignGroup() {
		 let item  = JSON.parse(JSON.stringify(this.Item));
		 this.$emit("saveNewCampaignGroup", item);      this.Item.name = "";
			this.Item.daily_budget = "";
			this.Item.strategy = "";
			this.showSpan = false;
		},
		cancelNewCampaignGroup() {
			this.Item.name = "";
			this.Item.daily_budget = "";
			this.Item.strategy = "";
			this.showSpan = false;
		},
		checkDuplicate(campaignName) {
			if (this.Item.name) {
				this.showLoader = true;
				var body = { name: campaignName };
				this.$store
					.dispatch("campaign/checkDuplicacyByName", body)
					.then(res => {
						if (res.total != 0) {
							this.Item.name = "";
							this.showSpan = true;
							// $("#addCampaignGroupName").attr(
							//   "placeholder",
							//   "Camapign Already Exist With That Name"
							// );
						} else {
							this.showSpan = false;
						}
						this.showLoader = false;
					});
			}
		},
		hideSpan() {
			this.showSpan = false;
		}
	}
};
</script>

<style lang="scss">
.campaign-g-addedit {
	.strategy {
		border: 1px solid #e3e3e3 !important;
		border-radius: 4px !important;
		min-height: 90px !important;
		padding: 25px !important;
		text-align: center !important;
		font-size: 20px !important;
		cursor: pointer !important;
	}
}
.campaign-g-addedit {
	.sales {
		border: 1px solid #aed2ca;
		background-color: #effffc;
		box-shadow: 0 15px 44px -20px rgba(1, 168, 131, 0.5);
	}
}
.campaign-g-addedit {
	.roi {
		border: 1px solid #bc97dc;
		background-color: #f6ebff;
		box-shadow: 0 15px 44px -20px rgba(147, 108, 180, 0.5);
	}
}
#addCampaignGroupName::placeholder{

	opacity: 1; /* Firefox */
}
</style>
